import React from "react"
import styled from "styled-components"
import Button from "../components/Button"

const RetCalcInput = ({
  setTestArray,
  handleClear,
  handleDefaults,
  doCalculations,
  startingAge,
  setStartingAge,
  startingSalary,
  setStartingSalary,
  annualRaisePercent,
  setAnnualRaisePercent,
  retirementAge,
  setRetirementAge,
  annualSavingsPercent,
  setAnnualSavingsPercent,
  interestRate,
  setInterestRate,
}) => {
  return (
    <Wrapper>
      <TopContainer>
        <label>
          Starting age: &nbsp;
          <input
            type="number"
            value={startingAge}
            onChange={e => setStartingAge(e.target.value)}
            min="0"
            max="99"
            required
          />
        </label>
        <label>
          Starting salary: &nbsp;
          <input
            type="number"
            value={startingSalary}
            onChange={e => setStartingSalary(e.target.value)}
            min="0"
            max="999999"
            required
          />
        </label>
        <label>
          Annual raise percent: &nbsp;
          <input
            type="number"
            value={annualRaisePercent}
            onChange={e => setAnnualRaisePercent(e.target.value)}
            min="0"
            max="100"
            step="0.1"
            required
          />
        </label>
        <label>
          Retirement age: &nbsp;
          <input
            type="number"
            value={retirementAge}
            onChange={e => setRetirementAge(e.target.value)}
            min="0"
            max="99"
            required
          />
        </label>
        <label>
          Annual savings percent: &nbsp;
          <input
            type="number"
            value={annualSavingsPercent}
            onChange={e => setAnnualSavingsPercent(e.target.value)}
            min="0"
            max="100"
            step="0.1"
            required
          />
        </label>
        <label>
          Interest rate: &nbsp;
          <input
            type="number"
            value={interestRate}
            onChange={e => setInterestRate(e.target.value)}
            min="0"
            max="100"
            step="0.1"
            required
          />
        </label>
      </TopContainer>
      <ButtonContainer>
        <Button text="Clear" small smallFont onClick={handleClear} />
        <Button text="Defaults" smallFont onClick={e => handleDefaults(e)} />
        <Button
          text="Calculate"
          primary
          smallFont
          onClick={e =>
            doCalculations(e)
              .then(detailTableArray => setTestArray(detailTableArray))
              .catch(
                () =>
                  console.log("Check the highlighted input boxes for errors.")
                // alert("Check the highlighted input boxes for errors.")
              )
          }
          // onClick={() =>
          //   handleCalculate(-1, 2, 3)
          //     .then(addition => {
          //       console.log(addition)
          //     })
          //     .catch(e => {
          //       console.log(e)
          //     })
          // }
        />
      </ButtonContainer>
    </Wrapper>
  )
}

export default RetCalcInput

const Wrapper = styled.form`
  /* background: lightcoral; */
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TopContainer = styled.div`
  /* background: paleturquoise; */
  width: 380px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 1.25rem;

  label:not(:first-child) {
    margin-top: 1.7vh;
  }

  input {
    font-size: 1.25rem;
    width: 100px;
    text-align: center;
    border: none;
    border-bottom: 2px solid #ccc;
    transition: 0.5s;
    outline: none;
  }

  input:focus {
    border-bottom: 2px solid #555;
  }

  input:invalid {
    border-bottom: 2px solid #ff0000;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  /* background: palevioletred; */
  width: 100%;
  max-width: 380px;
  margin: 10px 0;
`
